var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2748_3391)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#1CCA96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.01 20.999H30.01C30.01 15.869 26.137 12 21 12V14C25.062 14 28.01 16.943 28.01 20.999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 17.8147C23.1033 17.8147 24.0003 18.7117 24.0003 20.8147H26.0003C26.0003 17.5897 24.2253 15.8147 21.0003 15.8147V17.8147ZM24.4223 23.2577C24.2301 23.083 23.9776 22.9899 23.7181 22.9979C23.4585 23.0059 23.2123 23.1145 23.0313 23.3007L20.6383 25.7617C20.0623 25.6517 18.9043 25.2907 17.7123 24.1017C16.5203 22.9087 16.1593 21.7477 16.0523 21.1757L18.5113 18.7817C18.6977 18.6008 18.8064 18.3545 18.8144 18.0949C18.8225 17.8353 18.7292 17.5827 18.5543 17.3907L14.8593 13.3277C14.6843 13.135 14.4412 13.0182 14.1814 13.002C13.9217 12.9857 13.6659 13.0714 13.4683 13.2407L11.2983 15.1017C11.1254 15.2752 11.0222 15.5061 11.0083 15.7507C10.9933 16.0007 10.7073 21.9227 15.2993 26.5167C19.3053 30.5217 24.3233 30.8147 25.7053 30.8147C25.9073 30.8147 26.0313 30.8087 26.0643 30.8067C26.3088 30.793 26.5396 30.6894 26.7123 30.5157L28.5723 28.3447C28.7417 28.1472 28.8276 27.8915 28.8115 27.6317C28.7954 27.372 28.6788 27.1288 28.4863 26.9537L24.4223 23.2577Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2748_3391",
    x: -4,
    y: -4,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2748_3391"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2748_3391",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12);
export default __webpack_public_path__ + "static/media/Group12.8f5e00a72041f40f18c89d7016bc8e19.svg";
export { ForwardRef as ReactComponent };